import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const LCS_IndividualClinicalSupervision = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='LCS_IndividualClinicalSupervision' className='file-pdf-document'>
            <div className='file-template'>

            <p className='w-750'><h2>Life Changing Solutions LLC Individual Clinical Supervision</h2></p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Duration:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbDuration_1' name='cbDuration_1' className='add-only' value='1 hour' /> 1 hour</td>
                        <td className='w-250'> <input type='checkbox' id='cbDuration_2' name='cbDuration_2' className='add-only' value='2 hour' /> 2 hour</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Type:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbType_1' name='cbType_1' className='add-only' value='Individual' />Individual </td>
                        <td className='w-250'> <input type='checkbox' id='cbType_2' name='cbType_2' className='add-only' value='Group' /> Group</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Focus of Session</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbFocusSession_1' name='cbFocusSession_1' className='add-only' value='Case Review' />Case Review</td>
                        <td className='w-250'> <input type='checkbox' id='cbFocusSession_2' name='cbFocusSession_2' className='add-only' value='SkillsTraining' />PSR Skills Training</td>
                        <td className='w-250'> <input type='checkbox' id='cbFocusSession_3' name='cbFocusSession_3' className='add-only' value='Interventions' />CPST Interventions</td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbFocusSession_4' name='cbFocusSession_4' className='add-only' value='CrisisInterventionReview' />Crisis Intervention Review</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Behaviors addressed in sessions for the past 14 days</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbBehaviorsAddressedInSessions_1' name='cbBehaviorsAddressedInSessions_1' className='add-only' value='VerbalAggression' />Verbal aggression</td>
                        <td className='w-250'> <input type='checkbox' id='cbBehaviorsAddressedInSessions_2' name='cbBehaviorsAddressedInSessions_2' className='add-only' value='PhysicalAggression' />Physical aggression</td>
                        <td className='w-250'> <input type='checkbox' id='cbBehaviorsAddressedInSessions_3' name='cbBehaviorsAddressedInSessions_3' className='add-only' value='SymptomsDepression' />Symptoms of depression</td>

                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbBehaviorsAddressedInSessions_4' name='cbBehaviorsAddressedInSessions_4' className='add-only' value='SymptomsOfAnxiety' />Symptoms of anxiety</td>
                        <td className='w-250'> <input type='checkbox' id='cbBehaviorsAddressedInSessions_5' name='cbBehaviorsAddressedInSessions_5' className='add-only' value='Anger' />Anger</td>
                        <td className='w-250'> <input type='checkbox' id='cbBehaviorsAddressedInSessions_6' name='cbBehaviorsAddressedInSessions_6' className='add-only' value='RunningAway' />Running away</td>
                    </tr>

                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbBehaviorsAddressedInSessions_7' name='cbBehaviorsAddressedInSessions_7' className='add-only' value='Defiance' />Defiance</td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbBehaviorsAddressedInSessions_8' name='cbBehaviorsAddressedInSessions_8' className='add-only' value='Other' />Other:
                            <input type='text' id='textBehaviorsAddressedInSessions_9' name='textBehaviorsAddressedInSessions_9' className='add-only w-375 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Progress Towards Goals/Lack of progress</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='checkbox' id='cbProgressTowardsGoalsLackProgress_1' name='cbProgressTowardsGoalsLackProgress_1' className='add-only' value='MadeSignificantProgressTowardsGoals' />Made significant progress towards goals.</td>
                        <td className='w-375'> <input type='checkbox' id='cbProgressTowardsGoalsLackProgress_2' name='cbProgressTowardsGoalsLackProgress_2' className='add-only' value='MadeLittleToNoProgressTowardsGoals' />Made little to no progress towards goals </td>
                    </tr>
                </table>


                <p className='w-750'><h3>LMHP Feedback Actions for Supervisee</h3></p>
                <p className='w-750'><span className='small'>Include feedback about services and interventions</span> </p>
                <table>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>LMHP Feedback and suggestions?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbFeedbackSuggestions_1' name='cbFeedbackSuggestions_1' className='add-only' value='ContinueCourseTreatment' />Continue Course of Treatment </td>
                        <td className='w-250'> <input type='checkbox' id='cbFeedbackSuggestions_2' name='cbFeedbackSuggestions_2' className='add-only' value='WorkTowardsDischarge' />Work towards Discharge</td>
                        <td className='w-250'> <input type='checkbox' id='cbFeedbackSuggestions_3' name='cbFeedbackSuggestions_3' className='add-only' value='AddressParentingIssues' />Address Parenting Issues</td>

                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbFeedbackSuggestions_5' name='cbFeedbackSuggestions_5' className='add-only' value='ContinueBuildingRapportTrust' />Continue building rapport/trust</td>
                        <td className='w-250'> <input type='checkbox' id='cbFeedbackSuggestions_6' name='cbFeedbackSuggestions_6' className='add-only' value='NeedPsychiatricEval' />Need Psychiatric Eval </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbFeedbackSuggestions_4' name='cbFeedbackSuggestions_4' className='add-only' value='TransitionClientHigherLowerLevelCare' />Transition Client to higher/lower level of care </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbFeedbackSuggestions_7' name='cbFeedbackSuggestions_7' className='add-only' value='BeMoreDirectWith' />Be more direct with:
                            <input type='text' id='textFeedbackAndSuggestions_8' name='textFeedbackAndSuggestions_8' className='add-only w-375 custom-add-only' /></td>
                    </tr>
                    <tr><td className='w-750'> <input type='checkbox' id='cbFeedbackSuggestions_9' name='cbFeedbackSuggestions_9' className='add-only' value='Other' />Other:
                        <input type='text' id='textFeedbackAndSuggestions_10' name='textFeedbackAndSuggestions_10' className='add-only w-375 custom-add-only' /></td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Date of service</span></td>
                        <td className='w-500'><span className='eleHeader'>Notes(Feedback)</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='date' id='txtDateOfService_1' name='txtDateOfService_1' className='add-only' /></td>
                        <td className='w-500'> <input type='checkbox' id='cbNoteFeedback_1' name='cbNoteFeedback_1' className='add-only' value='ProgressNoteSufficient' />Progress note is sufficient <br /> <input type='checkbox' id='cbNoteFeedback_2' name='cbNoteFeedback_2' className='add-only' value='ProgressInsufficientAndMoreTrainingNeeded' />Progress note is insufficient and more training is needed </td>
                    </tr>


                    <tr>
                        <td className='w-250'><input type='date' id='txtDateOfService_2' name='txtDateOfService_2' className='add-only' /></td>
                        <td className='w-500'> <input type='checkbox' id='cbNoteFeedback_3' name='cbNoteFeedback_3' className='add-only' value='ProgressNoteSufficient' />Progress note is sufficient <br /><input type='checkbox' id='cbNoteFeedback_4' name='cbNoteFeedback_4' className='add-only' value='ProgressInsufficientAndMoreTrainingNeeded' />Progress note is insufficient and more training is needed</td>
                    </tr>


                    <tr>
                        <td className='w-250'><input type='date' id='txtDateOfService_3' name='txtDateOfService_3' className='add-only' /></td>
                        <td className='w-500'> <input type='checkbox' id='cbNoteFeedback_5' name='cbNoteFeedback_5' className='add-only' value='ProgressNoteSufficient' />Progress note is sufficient <br /><input type='checkbox' id='cbNoteFeedback_6' name='cbNoteFeedback_6' className='add-only' value='ProgressInsufficientAndMoreTrainingNeeded' />Progress note is insufficient and more training is needed</td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>LMHP Recommendations for training </span><span className='small'>List all recommendation for on-going training </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='checkbox' id='cbRecommendationsForTraining_1' name='cbRecommendationsForTraining_1' className='add-only' value='Documentation' />Documentation</td>
                        <td className='w-250'> <input type='checkbox' id='cbRecommendationsForTraining_2' name='cbRecommendationsForTraining_2' className='add-only' value='SkillsTraining' />PSR Skills Training</td>
                        <td className='w-250'> <input type='checkbox' id='cbRecommendationsForTraining_3' name='cbRecommendationsForTraining_3' className='add-only' value='EngagementTraining' />Engagement Training</td>
                    </tr>
                    <tr>

                        <td className='w-250'> <input type='checkbox' id='cbRecommendationsForTraining_4' name='cbRecommendationsForTraining_4' className='add-only' value='CrisisPlanning' />CrisisPlanning</td>
                        <td className='w-250'> <input type='checkbox' id='cbRecommendationsForTraining_5' name='cbRecommendationsForTraining_5' className='add-only' value='ConfidentialityTraining' />Confidentiality Training</td>
                        <td className='w-250'> <input type='checkbox' id='cbRecommendationsForTraining_6' name='cbRecommendationsForTraining_6' className='add-only' value='BoosterTraining' />Booster Training</td>
                    </tr>

                    <tr>
                        <td className='w-750'> <input type='checkbox' id='cbRecommendationsForTraining_7' name='cbRecommendationsForTraining_7' className='add-only' value='Other' />Other:
                         <input type='text' id='textRecommendationsForTraining_8' name='textRecommendationsForTraining_8' className='add-only w-375 custom-add-only' /></td>
                    </tr>
                </table>



 



            </div>
        </form>

    )
}  
